angular.module('tgaAdmin').controller('CaseOptionsModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'extras',
  'fileReader',
  '$translate',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, extras, fileReader, $translate) {
    $scope.data = {
      alerts: [],
      closeButton: extras.closeButton,
      key: extras.key,
      title: extras.data.name,
    };

    $scope.viewmodel = angular.copy(extras.question);

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $uibModalStack.getTop().value.backdrop = 'static';
        $uibModalStack.getTop().value.keyboard = false;
        $scope.data.closeButton = false;

        $scope.processing = true;

        const data = {};

        data[`${$scope.data.key}_title`] = $scope.viewmodel[`${$scope.data.key}_title`];
        data[`${$scope.data.key}_top`] = $scope.viewmodel[`${$scope.data.key}_top`];
        data[`${$scope.data.key}_body`] = $scope.viewmodel[`${$scope.data.key}_body`];
        data[`${$scope.data.key}_button`] = $scope.viewmodel[`${$scope.data.key}_button`];

        $uibModalInstance.close(data);
      },

      checkImage(image) {
        // console.log(image)
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      checkAudio(audio) {
        // console.log(audio)
        const allowed = /audio\/mpeg|audio\/mp3/.test(audio.file.type);

        if (!allowed) {
          audio = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (audio.file.size > 5242880) {
          audio = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Audio files cannot be more than 5 MB in size.',
            'danger',
          );
          return;
        }

        fileReader.readAsDataUrl(audio.file, $scope).then((result) => {
          audio.base64 = result;
          audio.filetype = audio.file.type;
          audio.filename = audio.file.name;
        });
      },
      checkVideo(video) {
        // console.log(video)
        const allowed = /video\/mp4/.test(video.file.type);

        if (!allowed) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (video.file.size > 104857600) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Video files cannot be more than 30 MB in size.',
            'danger',
          );
          return;
        }
        video.url = URL.createObjectURL(video.file);
      },
      videoEmbed(video) {
        if (video.url.includes('vimeo')) {
          const result = video.url.match(
            // eslint-disable-next-line max-len
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
          );
          video.url = `https://player.vimeo.com/video/${result[1]}`;
        } else if (video.url.includes('youtu')) {
          if (!video.url.includes('embed')) {
            const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
            video.url = `https://www.youtube.com/embed/${video.url.match(expr)[2]}`;
          }
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
  },
]);
